import { IDropdownMenuItem } from "@atomaro/ui-kit/components/DropdownMenu/types"
import { format } from "date-fns";
import { useApiariesStore } from "entities/apiaries"
import { useUserStore } from "entities/user";
import { useMemo, useRef, useState } from "react"
import { formatPhoneNumber, toRem } from "shared/helpers";
import profileImg from "shared/assets/img/user.png";
import { TableStyles } from "react-data-table-component";
import { COLORS } from "shared/consts";
import { useHudCollapse } from "widgets/hud/model/collapseStore";
import { toast } from "react-toastify";

export type EmpoyeeRow = {
  userId: string;
  avatar: string;
  fio: string;
  email: string;
  phone: string;
  birthDate: string;
  role: string;
}

export const useEmployees = () => {
  const currentApiary = useApiariesStore(s => s.currentApiaryVar);
  const userInfo = useUserStore(s => s.userInfo);
  const hudWidth = useHudCollapse(s => s.hudWidth);
  const [ searchString, setSearchString ] = useState<string>('')

  const deleteParticipant = useApiariesStore(s => s.deleteParticipant);
  const getApiaries = useApiariesStore(s => s.getApiaries);

    const sortItems = useRef<IDropdownMenuItem[]>([
      {
        key: 'fio',
        value: 'По ФИО'
      },
      {
        key: 'email',
        value: 'По Email'
      },
      {
        key: 'phone',
        value: 'По Телефону'
      },
      {
        key: 'birth',
        value: 'По Дате рождения'
      },
      {
        key: 'role',
        value: 'По Правам'
      },
    ])
  
  const customStyles: TableStyles = {
    table: {
      style: {
        maxWidth: `calc(100vw - ${toRem(hudWidth)} - ${toRem(15)})`,
        backgroundColor: 'transparent',
      }
    },
    headRow: {
      style: {
        backgroundColor: COLORS.BG.SURFACE3,
        borderTop: `${toRem(1)} solid ${COLORS.BORDER.SOFT}`,
        borderBottom: `${toRem(1)} solid ${COLORS.BORDER.SOFT}`,
        minHeight: '40px',
        color: COLORS.FG.DEFAULT
      }
    },
    rows: {
      style: {
        minHeight: '40px',
        borderBottom: `${toRem(1)} solid ${COLORS.BORDER.MUTED}`,
        cursor: 'pointer',
        backgroundColor: 'transparent',
        color: COLORS.FG.DEFAULT,
        '&:hover' : {
          backgroundColor: COLORS.BG.SURFACE2,
        }
      }
    },
    noData: {
      style: {
        backgroundColor: 'transparent',
        color: COLORS.FG.DEFAULT,
      }
    }
  }

  const [ isNewEmployeeOpen, setIsNewEmployeeOpen ] = useState<boolean>(false);
  const [ isDeleteEmployeeOpen, setIsDeleteEmployeeOpen ] = useState<boolean>(false);
  const [ deleteId, setDeleteId ] = useState<string | null>(null)

  // console.log(currentApiary?.participants);
  // console.log(currentApiary?.owner);

  const rows = useMemo(() => {
    if (currentApiary?.participants?.length) {
      const participantsArr: EmpoyeeRow[] = currentApiary?.participants
      ?.filter(participant => `${participant.name.first} ${participant.name.last} ${participant.name.patronymic}`.toLowerCase().includes(searchString.toLowerCase()))
      ?.map(participant => ({
        userId: participant.id,
        avatar: participant?.profile?.avatar?.id ? `/ecpp/attachments/files?attachmentId=${participant.profile.avatar.id}` : profileImg,
        fio: `${participant.name.first} ${participant.name.last}`,
        email: participant.credentials.email || '',
        phone: formatPhoneNumber(participant.credentials.login),
        role: userInfo?.id !== participant.id ? 'Сотрудник' : 'Администратор',
        birthDate: participant.profile.birthday ? format(participant.profile.birthday, 'dd.MM.yyyy') : ''
      }));
  
      if (
        currentApiary?.owner&&
        `${currentApiary?.owner.name.first} ${currentApiary?.owner.name.last} ${currentApiary?.owner.name.patronymic}`.toLowerCase().includes(searchString.toLowerCase())
      ) {
        const avatar = profileImg;
        // if (currentApiary.owner?.profile?.avatar?.id) {
        //   avatar = `/ecpp/attachments/files?attachmentId=${currentApiary.owner.profile.avatar.id}`;
        // } else if (currentApiary.owner?.id === userInfo?.id&&userInfo.profile.avatar?.id) {
        //   avatar = `/ecpp/attachments/files?attachmentId=${userInfo.profile.avatar?.id}`;
        // }
        participantsArr?.push({
          userId: currentApiary.owner.id,
          avatar,
          fio: `${currentApiary.owner.name.first} ${currentApiary.owner.name.last} ${currentApiary.owner.name.patronymic}`,
          email: currentApiary.owner.credentials.email || '',
          phone: formatPhoneNumber(currentApiary.owner.credentials.login),
          role: 'Администратор',
          birthDate: currentApiary.owner.profile.birthday ? format(currentApiary.owner.profile.birthday, 'dd.MM.yyyy') : ''
        })
      }

      return participantsArr;
    }

    return []
  }, [currentApiary, searchString])

  const onDeleteClick = (id: string) => {
    setDeleteId(id)
    setIsDeleteEmployeeOpen(true);
  }

  const onDeleteClose = () => {
    setDeleteId(null)
    setIsDeleteEmployeeOpen(false);
  }

  const onDeleteConfirm = async () => {
    if (!deleteId) {
      setDeleteId(null)
      setIsDeleteEmployeeOpen(false);
      return
    }

    const isDeleted = await deleteParticipant(deleteId);
    if (isDeleted) {
      toast.success('Сотрудник удалён');
    } else {
      toast.error('Что-то пошло не так');
    }

    await getApiaries(userInfo?.id);
    setDeleteId(null);
    setIsDeleteEmployeeOpen(false);
  }

  return {
    sortItems,
    isNewEmployeeOpen,
    rows,
    userInfo,
    customStyles,
    searchString,
    isDeleteEmployeeOpen,
    setIsNewEmployeeOpen,
    setSearchString,
    onDeleteClick,
    onDeleteClose,
    onDeleteConfirm,
  }
}